<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
      ref="filterRef"
      :filters="filtersConfig"
      :display-advanced="false"
      search-icon="fa fa-sync pr-2"
      search-text=""
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="filterModel"
      @search="onProcessHandler"
    >
      <div class="col d-flex justify-content-end align-items-center">
        <dropdown
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import Dropdown from 'dropdown';

//services
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js';

export default {
  name: 'ProviderBills',
  components: {
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    filterOptions: {
      academicYears: [],
    },
    filterModel: {
      academicYear: null,
      serviceAssistantFlag: false,
    },
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Facturas de Proveedores',
        routes: ['Inicio', 'Reportes', 'Facturas de Proveedores'],
      };
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.filterOptions.academicYears,
        },
        {
          name: 'serviceAssistantFlag',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Asistente de Servicio',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.filterOptions.serviceAssistantOption,
        },
      ];
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromToCurrentYear(
          codeAcademicYear['2016-2017']
        )
      ).data;

      this.filterOptions.serviceAssistantOption = [
        { id: 0, name: 'No' },
        { id: 1, name: 'Si' },
      ];
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      await ReportServices.getReport('rpprovidersinvoices', {
        academicYearId: this.filterModel.academicYear.id,
        serviceAssistantFlag: this.filterModel?.serviceAssistantFlag?.id,
        isPdfFormat,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>
